// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"c0882e34","133":"08460ad3","259":"a394fc48","288":"954c9586","331":"0414b6be","453":"79f5612f","479":"62eee48f","633":"6d2f85e9","984":"8fc9e5af"}[chunkId] + ".chunk.js";
};